import React from 'react';

export function Level(props){
    let fsize = "overlap p-2";
    if(props.edit_template === "true")
    {
        fsize="preview_overlap";
    }
    return (
       <p class={`${fsize} B2`}><span><strong>{props.level}</strong></span></p> 
    )
}